import React from 'react';
import { useMediaQuery } from 'react-responsive';
import RGL, { WidthProvider } from "react-grid-layout";
import CustomScrollbars from 'util/CustomScrollbars';
import {useSelector, useDispatch} from 'react-redux'
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import { withStyles } from '@material-ui/core/styles';
import { ModalHeader } from 'reactstrap';
import {Grid,Paper } from '@material-ui/core'
//
import ExcelVy from './ExcelVy'
import RapportFunctions from './RapportFunctions'
import RapportChips from './RapportChips'
import RapportSection from './RapportSection'
import SparadRapport from './SparadRapport'
import RapportLogg from './RapportLogg'
import {isEmpty} from 'lodash'
import {getSamplesImport,setToZeroImportSample,onGetRapportV2J,onGetAndSaveRapportV2J,
    onSetToNullImportSamplesMessage,getLoggRepportV2,getSparadRepportV2,getCurrentObjektById
} from 'actions'
//
import SkapaRapportPopUp from './SkapaRapportPopUp'
import WarningIcon from '@material-ui/icons/Warning';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import IntlMessages from 'util/IntlMessages';
const ReactGridLayout = WidthProvider(RGL);

const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 992, maxWidth: 1199 })
    return isDesktop ? children : null
  }
  const LargeDesktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1200, maxWidth: 1499 })
    return isDesktop ? children : null
  }
  const ExtraLargeDesktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1500, maxWidth: 1799 })
    return isDesktop ? children : null
  }
  const XXLargeDesktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1800 })
    return isDesktop ? children : null
  }
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    return isTablet ? children : null
  }
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return isMobile ? children : null
  }
  
//
const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
function RapportV2(props) {
    const dispatch = useDispatch()
    const Flags = useSelector(state=>state.accountsData.Flags)
    const ImportSamplesMessage = useSelector(state=>state.accountsData.ImportSamplesMessage)
    const authUser = useSelector(state=>state.auth.authUser)
    const [DisabledArr, setDisabledArr] = React.useState({
        Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:false,
        Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
        Offert:false,
    })
    const handleClose = () => {
        console.log("Closer")
        props.onClosePopUP()
    };
    const [Filterstate,setFilterstate]=React.useState([])
    const [openPop, setOpenPop] = React.useState(false)
    const [id,setId]=React.useState(0)
    const [SendTo,setSendTo]=React.useState("")
    const [Name,setName]=React.useState("")
    const [beskrivning,setBeskrivning]=React.useState("")
    const onOpenSavePopUp=()=>{
        setOpenPop(true)
    }
    const onCloseSavePopUp=()=>{
        setOpenPop(false)
    }
    const onChangeHandle=(Meta,Value)=>{
        onSetAllFilterState(Value)
    }
    const handleDeleteOptions = (item)=>{
        let OptionsList = Filterstate.filter(n=>{return n !==item})
        setFilterstate(OptionsList)
    }
    const resetZeroChips = ()=>{
        setFilterstate([])
        setDisabledArr([])
    }
    React.useEffect(()=>{
        if(!isEmpty(ImportSamplesMessage)){
            const timeout = setTimeout(() => {
                dispatch(onSetToNullImportSamplesMessage())
            }, 5000)
        }
    },[ImportSamplesMessage])
    React.useEffect(()=>{
        let DisabledArr1 ={  Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:false,
            Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
            Offert:false,}
        if(Filterstate.some(item => item.MetaN.includes("Order_"))){
            DisabledArr1={
                Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:true,
    Order:false,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
    Offert:true,
            }
            setDisabledArr(DisabledArr1)
        }
        else if(Filterstate.some(item => item.MetaN.includes("Projekt_"))){
            DisabledArr1={
                Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:false,
            Order:false,Esignering:true,Fakturering:true,Arende:true,Projekt:false,Aktiviteter:true,
            Offert:true,
            }
            setDisabledArr(DisabledArr1) 
        }
        else if(Filterstate.some(item => item.MetaN.includes("Esignering_"))){
            DisabledArr1={
                Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:true,
            Order:true,Esignering:false,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
            Offert:true,
            }
            setDisabledArr(DisabledArr1) 
        }
        else if(Filterstate.some(item => item.MetaN.includes("Aktivitet_"))){
            DisabledArr1={
                Kund:false,Kontakter:false,Artiklar:true,Avtal:false,Prospekt:false,Event:true,
            Order:true,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:false,
            Offert:true,
            }
            setDisabledArr(DisabledArr1) 
        }
        else if(Filterstate.some(item => item.MetaN.includes("Aktivitet_"))){
            DisabledArr1={
                Kund:false,Kontakter:false,Artiklar:true,Avtal:false,Prospekt:false,Event:false,
    Order:true,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
    Offert:true,
            }
            setDisabledArr(DisabledArr1) 
        }
        else if(Filterstate.some(item => item.MetaN.includes("Aktivitet_"))){
            DisabledArr1={
                Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:false,
    Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
    Offert:false,
            }
            setDisabledArr(DisabledArr1) 
        }
        else if(Filterstate.some(item => item.MetaN.includes("Aktivitet_"))){
            DisabledArr1={
                Kund:false,Kontakter:false,Artiklar:false,Avtal:true,Prospekt:false,Event:false,
    Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
    Offert:false,
            }
            setDisabledArr(DisabledArr1) 
        }
        else if(Filterstate.some(item => item.MetaN.includes("Aktivitet_"))){
            DisabledArr1={
                Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:true,Event:false,
    Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
    Offert:false,
            }
            setDisabledArr(DisabledArr1) 
        }else{
            DisabledArr1={
                Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:false,
    Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
    Offert:false,
            }
            setDisabledArr(DisabledArr1) 
        }

    },[Filterstate])
    const onSetAllFilterState=(RapportType)=>{
        let FilterstateArr = []
        let ArrItem =[]
        let DisabledArr1 = DisabledArr
        switch(RapportType){
             //Kunder
             case "Kunder":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:false,
        Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
        Offert:false,
                }
                setDisabledArr(DisabledArr1)
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},                    
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column",isSwitch:true},                    
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Typ",MetaN:"Kund_Kundtyp",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Status",MetaN:"Kund_Status",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Adress",MetaN:"Kund_Adress",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"E-mailadress",MetaN:"Kund_Epost",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Skapad",MetaN:"Kund_Skapad",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Ägare",MetaN:"Kund_Ansvarig",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Skapad av",MetaN:"Kund_Huvudansvarig",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Taggar",MetaN:"Kund_Taggning",Value:-1,Type:"Column",isSwitch:true}
                ]
                
                setFilterstate(ArrItem)
            break;
            
            //Kunder med artiklar
            case "Kunder med artiklar":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:false,
        Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
        Offert:false,
                }
                setDisabledArr(DisabledArr1)
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column",isSwitch:true},                    
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Artikelnr",MetaN:"Artikel_Nr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Artikel",MetaN:"Artikel_Namn",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Antal",MetaN:"Artikel_Antal",Value:-1,Type:"Column",isSwitch:true}                  
                ]
                setFilterstate(ArrItem)
            break;
            case "Avtal":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:true,Event:false,
        Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
        Offert:false,
                }
                setDisabledArr(DisabledArr1)
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"AvtalID",MetaN:"Avtal_ID",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Avtalstyp",MetaN:"Avtal_Typ",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Leverantör",MetaN:"Avtal_Leverantor",Value:-1,Type:"Column",isSwitch:true},
                    
                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Rubrik",MetaN:"Avtal_Rubrik",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Värde",MetaN:"Avtal_TB",Value:-1,Type:"Column",isSwitch:true},
                    
                    {Meta:"Löpande",MetaN:"Avtal_MLopande",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Löper ut",MetaN:"Avtal_loperDatum",Value:-1,Type:"Column",isSwitch:true},                    
                    {Meta:"Omförhandling",MetaN:"Avtal_omforDatum",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Status",MetaN:"Avtal_status",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Ägare",MetaN:"Avtal_Ansvarig",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Kontaktperson namn",MetaN:"Kontaktperson_namn",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kontaktperson epost",MetaN:"Kontaktperson_Epost",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kontaktperson Tele",MetaN:"Kontaktperson_tele",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kontaktperson personnr",MetaN:"Kontaktperson_personnr",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Taggar",MetaN:"Avtal_Taggning",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"FakturaStatus",MetaN:"Avtal_fakturastatus",Value:-1,Type:"Column",isSwitch:true}, 
                    {Meta:"Fakturadatum",MetaN:"Avtal_FakturaDatum",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Betaldatum",MetaN:"Avtal_BetaltDatum",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Med Förlorad",MetaN:"Avtal_Forlorad",Value:1,Type:"ColumnH",isSwitch:true},
                    {Meta:"Anledning",MetaN:"Avtal_Forlorad_Reason",Value:-1,Type:"Column"},
                    {Meta:"Kommentar",MetaN:"Avtal_Forlorad_Comment",Value:-1,Type:"Column"},
                    {Meta:"Förlorad Datum",MetaN:"Avtal_Forlorad_ForlardDatum",Value:-1,Type:"Column"},

                    {Meta:"Med leverantör",MetaN:"Avtal_Mleverantör",Value:1,Type:"ColumnH",isSwitch:true},
                    {Meta:"Leverantör Orgnr",MetaN:"Avtal_Kund_Leverantor",Value:-1,Type:"Column"},
                    {Meta:"Leverantör Kund",MetaN:"Avtal_Kund_Leverantor_Orgnr",Value:-1,Type:"Column"},
                ]
               
                setFilterstate(ArrItem)
            break;
              
            case "Prospekt":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:true,Prospekt:false,Event:false,
        Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
        Offert:false,
                }
                setDisabledArr(DisabledArr1)
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"ProspektID",MetaN:"Prospekt_ID",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Prospektstyp",MetaN:"Prospekt_Typ",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Leverantör",MetaN:"Prospekt_Leverantor",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true},
                    
                    {Meta:"Rubrik",MetaN:"Prospekt_Rubrik",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"TB summa",MetaN:"Prospekt_TB",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"DeadLine",MetaN:"Prospekt_deadline_Datum",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Skapad datum",MetaN:"Prospekt_skapad_Datum",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Fas",MetaN:"Prospekt_Fas",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Ägare",MetaN:"Prospekt_Ansvarig",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Kontaktperson namn",MetaN:"Kontaktperson_namn",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kontaktperson epost",MetaN:"Kontaktperson_Epost",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kontaktperson Tele",MetaN:"Kontaktperson_tele",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kontaktperson personnr",MetaN:"Kontaktperson_personnr",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Taggar",MetaN:"Prospekt_Taggning",Value:-1,Type:"Column",isSwitch:true},
                    
                    {Meta:"Med Förlorad",MetaN:"Prospekt_Forlorad",Value:1,Type:"ColumnH",isSwitch:true},
                    {Meta:"Anledning",MetaN:"Prospekt_Forlorad_Reason",Value:-1,Type:"Column"},
                    {Meta:"Kommentar",MetaN:"Prospekt_Forlorad_Comment",Value:-1,Type:"Column"},
                    {Meta:"Förlorad Datum",MetaN:"Prospekt_Forlorad_ForlardDatum",Value:-1,Type:"Column"},

                    {Meta:"Med leverantör",MetaN:"Prospekt_Mleverantör",Value:1,Type:"ColumnH",isSwitch:true},
                    {Meta:"Leverantör Orgnr",MetaN:"Prospekt_Kund_Leverantor",Value:-1,Type:"Column"},
                    {Meta:"Leverantör Kund",MetaN:"Prospekt_Kund_Leverantor_Orgnr",Value:-1,Type:"Column"},
                ]
               
                setFilterstate(ArrItem)
            break;
            case "Order":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:true,
        Order:false,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
        Offert:true,
                }
                setDisabledArr(DisabledArr1)
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"OrderNr",MetaN:"Order_Nr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Typ",MetaN:"Order_Typ",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Leverantör",MetaN:"Order_Leverantor",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true},
                    
                    {Meta:"Typ av affär",MetaN:"Order_TypAvAffar",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Anteckningar",MetaN:"Order_Anteckningar",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Artikel Etiketter",MetaN:"Artikel_Taggar",Value:-1,Type:"Column",isSwitch:true},
                    
                    {Meta:"Värde totalt",MetaN:"Order_Varde_Totalt",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Värde TB1",MetaN:"Order_Varde_TB",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Värde TB1 intäkt",MetaN:"Order_Varde_TB_Intakter",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Värde TB1 Kostnad",MetaN:"Order_Varde_TB_Kostnader",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Löpande",MetaN:"Order_lopande",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Löpande intäkt",MetaN:"Order_lopande_intakter",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Löpande kostnad",MetaN:"Order_lopande_kostnad",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Regdatum",MetaN:"Order_Regdate",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Skapad",MetaN:"Order_skapadDate",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Antal Nya",MetaN:"Order_Antal_Ny",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Antal Förlängning",MetaN:"Order_Antal_For",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Porteringar (Till operatör)",MetaN:"Order_Porteringar",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Ägare",Value:-1,MetaN:"Order_Ansvarig",Type:"Column",isSwitch:true},

                    {Meta:"Status",Value:-1,MetaN:"Order_Status",Type:"Column",isSwitch:true},

                    {Meta:"Kontakt namn",MetaN:"Kontaktperson_namn",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kontakt e-post",MetaN:"Kontaktperson_Epost",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Affär från",MetaN:"Order_Affar_From",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Mötesbokare",MetaN:"Order_Motesbokare",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Växel",MetaN:"Order_Vaxel",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Taggar",MetaN:"Order_Tagger",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Med leverantör",MetaN:"Order_Mleverantör",Value:1,Type:"ColumnH",isSwitch:true},
                    {Meta:"Leverantör Orgnr",MetaN:"Order_Kund_Leverantor",Value:-1,Type:"Column"},
                    {Meta:"Leverantör Kund",MetaN:"Order_Kund_Leverantor_Orgnr",Value:-1,Type:"Column"},                  
                ]
                setFilterstate(ArrItem)
            break;
              //Kontaktpersoner
              case "Kontaktpersoner":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:false,
        Order:false,Esignering:false,Fakturering:false,Arende:false,Projekt:false,Aktiviteter:false,
        Offert:false,
                }
                setDisabledArr(DisabledArr1)
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"Kontaktperson ID",MetaN:"Kontaktperson_ID",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column",isSwitch:true},                    
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true},             

                    {Meta:"Kontaktperson namn",MetaN:"Kontaktperson_namn",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Kontaktperson tele",MetaN:"Kontaktperson_tele",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Kontaktperson e-post",MetaN:"Kontaktperson_Epost",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Kontaktperson roll",MetaN:"Kontaktperson_roll",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Kontaktperson PersonNr",MetaN:"Kontaktperson_personnr",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Firmatecknare",MetaN:"Kontaktperson_Firmatecknare",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Nyhetsbrev",MetaN:"Kontaktperson_Nyhetsbrev",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Ägare",MetaN:"Kontaktperson_Ansvarig",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Skapad",MetaN:"Kontaktperson_Skapad",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Taggar",MetaN:"Kontaktperson_Taggar",Value:-1,Type:"Column",isSwitch:true},                
                ]
                setFilterstate(ArrItem)
            break;
              //Moten
              case "Moten":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:true,Avtal:false,Prospekt:false,Event:false,
        Order:true,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
        Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"MöteId",MetaN:"Event_ID",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column",isSwitch:true},                    
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true},                
                    
                    {Meta:"Ny/Befintlig",MetaN:"Event_NyBefintling",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Mötestyp",MetaN:"Event_type",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Syfte",MetaN:"Event_title",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Start",MetaN:"Event_Start",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"End",MetaN:"Event_End",Value:-1,Type:"Column",isSwitch:true},          
                    {Meta:"Utfall",MetaN:"Event_Utfall",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Status",MetaN:"Event_Status",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Bokat datum",MetaN:"Event_BokadDatum",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Avbokat datum",MetaN:"Event_AvBokadDatum",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Beskrivning",MetaN:"Event_Beskrivning",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Intern Kommentar",MetaN:"Event_InternKommentar",Value:-1,Type:"Column",isSwitch:true}, 

                    {Meta:"Kontaktperson namn",MetaN:"Kontaktperson_namn",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Kontaktperson tele",MetaN:"Kontaktperson_Epost",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Kontaktperson e-post",MetaN:"Kontaktperson_tele",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Kontaktperson roll",MetaN:"Kontaktperson_roll",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Kontaktperson PersonNr",MetaN:"Kontaktperson_personnr",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Firmatecknare",MetaN:"Kontaktperson_Firmatecknare",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Nyhetsbrev",MetaN:"Kontaktperson_Nyhetsbrev",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Ansvarig",MetaN:"Event_Ansvarig",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Skapad",MetaN:"Event_skapadAv",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Taggar",MetaN:"Event_Taggar",Value:-1,Type:"Column",isSwitch:true},                
                ]
                setFilterstate(ArrItem)
            break;
            //Aktiviteter
            case "Aktiviteter":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:true,Avtal:false,Prospekt:false,Event:true,
                Order:true,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:false,
                Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},

                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true}, 
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true}, 
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true}, 
                    {Meta:"KundId",MetaN:"Kund_KundId",Value:-1,Type:"Column",isSwitch:true}, 
                    
                    {Meta:"Ägare av aktiviteten",MetaN:"Aktivitet_Ansvarig",Value:-1,Type:"Column",isSwitch:true},        
                    {Meta:"Typ av aktivitet",MetaN:"Aktivitet_Typ",Value:-1,Type:"Column",isSwitch:true},        

                    {Meta:"Skapad datum",MetaN:"Aktivitet_skapaddate",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Status",MetaN:"Aktivitet_Status",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Klarmarkerad datum",MetaN:"Aktivitet_Klardatum",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Förfallodatum",MetaN:"Aktivitet_Duedatum",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Beskrivningsfältet",MetaN:"Aktivitet_beskrivning",Value:-1,Type:"Column",isSwitch:true}
                ]
                setFilterstate(ArrItem)
            break;
             //E-signering
             case "E-signering":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:true,
                Order:false,Esignering:false,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
                Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"EsigneringNr",MetaN:"Esignering_ID",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"KundNR",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true},
                    
                    {Meta:"Ansvarig",MetaN:"Esignering_Ansvarig",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Filtyp",MetaN:"Esignering_Type",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Mottagare",MetaN:"Esignering_Mottagare",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Status",MetaN:"Esignering_Status",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Senaste händelse",MetaN:"Esignering_Seneste",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"taggar",MetaN:"Esignering_Taggar",Value:-1,Type:"Column",isSwitch:true}
                ]
                setFilterstate(ArrItem)
            break;
             //Projekt
             case "Projekt":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:false,
                Order:false,Esignering:true,Fakturering:true,Arende:true,Projekt:false,Aktiviteter:true,
                Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"ProjectName",MetaN:"Projekt_ProjectName",Value:-1,Type:"Column",isSwitch:true},  

                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true},                
                    
                    {Meta:"Medarbetare",MetaN:"Projekt_Medarbetare",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Ägare",MetaN:"Projekt_Ansvarig",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Taggar",MetaN:"Projekt_Taggar",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Arbetade timmar",MetaN:"Projekt_Tid_ArbetadeTimmar",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Kalkylerade timmar",MetaN:"Projekt_KalkyleradeTimmar",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Start",MetaN:"Projekt_StartDatum",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Deadline",MetaN:"Projekt_deadline",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Fas",MetaN:"Projekt_Fas",Value:-1,Type:"Column",isSwitch:true},                
                    {Meta:"Status",MetaN:"Projekt_Status",Value:-1,Type:"Column",isSwitch:true},               
                ]
                setFilterstate(ArrItem)
            break;
              //Offert
              case "Offert":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:true,
                Order:false,Esignering:false,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
                Offert:false,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"Offertnr",MetaN:"Offert_Offertnr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Offertnamn",MetaN:"Offert_Offertnamn",Value:-1,Type:"Column",isSwitch:true},
                    
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column",isSwitch:true},
                    
                    {Meta:"Ansvarig",MetaN:"Offert_Ansvarig",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Typ",MetaN:"Offert_Typ",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Status",MetaN:"Offert_Status",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Deadline",MetaN:"Offert_Deadline",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Skapad",MetaN:"Offert_Skapad",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Artikelnr",MetaN:"Artikel_Nr",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Artikelnamn",MetaN:"Artikel_Namn",Value:-1,Type:"Column",isSwitch:true},
                    
                    //{Meta:"Antal",MetaN:"Antal",Value:-1,Type:"Column"},
                    //{Meta:"Utpris",MetaN:"Utpris",Value:-1,Type:"Column"},
                    //{Meta:"Inpris",MetaN:"Inpris",Value:-1,Type:"Column"},
                    //{Meta:"TB",MetaN:"TB",Value:-1,Type:"Column"},
                    //{Meta:"Rabatt",MetaN:"Rabatt",Value:-1,Type:"Column"},
                    //{Meta:"Summa",MetaN:"Summa",Value:-1,Type:"Column"},
                    {Meta:"Taggar",MetaN:"Offert_Taggar",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Prospekt ID",MetaN:"Prospekt_ID",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Sannolikhet (från prospekt)",MetaN:"Prospekt_Sannolikhet",Value:-1,Type:"Column",isSwitch:true},

                    {Meta:"Kontaktperson namn",MetaN:"Kontaktperson_namn",Value:-1,Type:"Column",isSwitch:true},
                    {Meta:"Kontaktperson epost",MetaN:"Kontaktperson_Epost",Value:-1,Type:"Column",isSwitch:true},
                ]
                setFilterstate(ArrItem)
            break;
            /*case "Order kunddata":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:true,
        Order:false,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
        Offert:true,
                }
                setDisabledArr(DisabledArr1)
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"OrderNr",MetaN:"Order_Nr",Value:-1,Type:"Column"},

                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column"},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column"},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column"},
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column"},

                    {Meta:"Taggar",Value:-1,Type:"Column"}
                ]
               
                setFilterstate(ArrItem)
            break;
            //Order med artiklar
            case "Order kunddata":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:true,
        Order:false,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
        Offert:true,
                }
                setDisabledArr(DisabledArr1)
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"OrderNr",MetaN:"Order_Nr",Value:-1,Type:"Column"},
                    {Meta:"Taggar",MetaN:"Taggar",Value:-1,Type:"Column"},
                    {Meta:"Datum",MetaN:"Datum",Value:-1,Type:"Column"},
                ]
                
                setFilterstate(ArrItem)
            break;
          //Order provision
            case "Order provision":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:false,Avtal:false,Prospekt:false,Event:true,
        Order:false,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
        Offert:true,
                }
                setDisabledArr(DisabledArr1)
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"OrderNr",MetaN:"Order_Nr",Value:-1,Type:"Column"},

                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column"},
                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column"},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column"},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column"},

                    {Meta:"Användare",MetaN:"Användare",Value:-1,Type:"Column"},
                    {Meta:"Taggar",MetaN:"Taggar",Value:-1,Type:"Column"},
                    {Meta:"Provision",MetaN:"Provision",Value:-1,Type:"Column"},
                    {Meta:"Utpris",MetaN:"Utpris",Value:-1,Type:"Column"},
                    {Meta:"Inpris",MetaN:"Inpris",Value:-1,Type:"Column"},
                    {Meta:"TB",MetaN:"TB",Value:-1,Type:"Column"},
                    {Meta:"TB2",MetaN:"TB2",Value:-1,Type:"Column"},
                    {Meta:"Regdatum",MetaN:"Regdatum",Value:-1,Type:"Column"},
                ]
                
                setFilterstate(ArrItem)
            break;
           
            
            //Kunder händelser
            case "Kunder händelser":
                DisabledArr1={
                    Kund:false,Kontakter:true,Artiklar:true,Avtal:true,Prospekt:true,Event:true,
        Order:true,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
        Offert:true,
                }
                setDisabledArr(DisabledArr1)
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column"},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column"},
                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column"},                    
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column"},                
                ]
                setFilterstate(ArrItem)
            break;
          
          
            //Ärende
            case "Ärende":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:true,Avtal:true,Prospekt:true,Event:true,
        Order:true,Esignering:true,Fakturering:true,Arende:false,Projekt:true,Aktiviteter:true,
        Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"Ärendenummer",MetaN:"Arende_ArendeNr",Value:-1,Type:"Column"},

                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column"},                

                    {Meta:"Skapad",MetaN:"Arende_SkapadDate",Value:-1,Type:"Column"},
                    {Meta:"Ändrad",MetaN:"Arende_UpdateDate",Value:-1,Type:"Column"},
                    {Meta:"Ansvarig",MetaN:"Arende_Ansvarig",Value:-1,Type:"Column"},                    
                    
                    {Meta:"Status",MetaN:"Arende_Status",Value:-1,Type:"Column"},                
                    {Meta:"Prio",MetaN:"Arende_Prio",Value:-1,Type:"Column"},                
                    {Meta:"Larmorsak",MetaN:"Arende_Nmss_Larmorsak",Value:-1,Type:"Column"},                
                    {Meta:"Ärendetyp",MetaN:"Arende_ArendeTyp",Value:-1,Type:"Column"},                
                    {Meta:"Kategori",MetaN:"Arende_Kategori",Value:-1,Type:"Column"},      

                    {Meta:"Ägare",MetaN:"Arende_Ansvarig1",Value:-1,Type:"Column"},                
                    {Meta:"Skadeärendenr",MetaN:"Arende_Nmss_SkadeArendeNr",Value:-1,Type:"Column"},                
                    {Meta:"Telefonnummer",MetaN:"Arende_Telefonnummer",Value:-1,Type:"Column"},                
                    {Meta:"Uppskattat pris (ex moms)",MetaN:"Arende_Nmss_Upris",Value:-1,Type:"Column"},                
                    {Meta:"Verkligt pris",MetaN:"Arende_Nmss_Vpris",Value:-1,Type:"Column"},                

                    {Meta:"Faktura",MetaN:"Arende_Nmss_Faktura",Value:-1,Type:"Column"},                
                    {Meta:"Beskrivning",MetaN:"Arende_Beskrivning",Value:-1,Type:"Column"},                
                    {Meta:"Förslag på åtgärd",MetaN:"Arende_Atgrad",Value:-1,Type:"Column"},                
                               
                    {Meta:"Flöde",MetaN:"Arende_Flode",Value:-1,Type:"Column"},                
                    {Meta:"Medlemsbåt",MetaN:"Arende_Nmss_MedlemBoot",Value:-1,Type:"Column"},                
                    {Meta:"Båttillverkare",MetaN:"Arende_Nmss_tillverkare",Value:-1,Type:"Column"},                
                    {Meta:"Lat",MetaN:"Arende_Nmss_Lat",Value:-1,Type:"Column"},                
                    {Meta:"Long",MetaN:"Arende_Nmss_Long",Value:-1,Type:"Column"},                
                    {Meta:"Skadeplats",MetaN:"Arende_Nmss_Skadeplats",Value:-1,Type:"Column"},                
                    {Meta:"Region",MetaN:"Arende_Nmss_Region",Value:-1,Type:"Column"},                

                    {Meta:"Kontaktperson namn",MetaN:"Kontaktperson_namn",Value:-1,Type:"Column"},                
                    {Meta:"Kontaktperson tele",MetaN:"Kontaktperson_tele",Value:-1,Type:"Column"},                
                    {Meta:"Kontaktperson e-post",MetaN:"Kontaktperson_Epost",Value:-1,Type:"Column"},                
                    {Meta:"Kontaktperson roll",MetaN:"Kontaktperson_roll",Value:-1,Type:"Column"},                
                    {Meta:"Kontaktperson PersonNr",MetaN:"Kontaktperson_personnr",Value:-1,Type:"Column"},  

                   {Meta:"Taggar",MetaN:"Arende_Taggar",Value:-1,Type:"Column"},                
                ]
                setFilterstate(ArrItem)
            break;
            //Tillgodo
            case "Tillgodo":
                DisabledArr1={
                    Kund:false,Kontakter:true,Artiklar:true,Avtal:true,Prospekt:true,Event:true,
                Order:true,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
                Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column"},        
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column"},                
                ]
                setFilterstate(ArrItem)
            break;
           
            //Projekt Tidsrapport
            case "Projekt Tidsrapport":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:true,Avtal:true,Prospekt:true,Event:true,
                Order:true,Esignering:true,Fakturering:true,Arende:true,Projekt:false,Aktiviteter:true,
                Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"Användare",MetaN:"Användare",Value:-1,Type:"Fixed"},        
                    {Meta:"Typ",MetaN:"Typ",Value:-1,Type:"Column"},        
                    {Meta:"Kategori",MetaN:"Kategori",Value:-1,Type:"Column"},                
                    {Meta:"Kommentar",MetaN:"Kommentar",Value:-1,Type:"Column"},                
                    {Meta:"Registrerad",MetaN:"Registrerad",Value:-1,Type:"Column"},                
                    {Meta:"Arbetade timmar",MetaN:"Arbetade timmar",Value:-1,Type:"Column"},                
                    {Meta:"Fakturerbara timmar",MetaN:"Fakturerbara timmar",Value:-1,Type:"Column"}
                ]
                setFilterstate(ArrItem)
            break;
            
            //Order artiklar
            case "Order artiklar":
                DisabledArr1={
                    Kund:true,Kontakter:true,Artiklar:false,Avtal:true,Prospekt:true,Event:true,
                Order:true,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:false,
                Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                ]
                setFilterstate(ArrItem)
            break;
            //Avtalsfakturering
            case "Avtalsfakturering":
                DisabledArr1={
                    Kund:false,Kontakter:false,Artiklar:true,Avtal:false,Prospekt:true,Event:true,
                Order:true,Esignering:true,Fakturering:false,Arende:true,Projekt:true,Aktiviteter:false,
                Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"AvtalID",MetaN:"Avtal_ID",Value:-1,Type:"Column"},
                    {Meta:"Avtalstyp",MetaN:"Avtal_Typ",Value:-1,Type:"Column"},
                    {Meta:"Leverantör",MetaN:"Avtal_Leverantor",Value:-1,Type:"Column"},

                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column"},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column"},
                    {Meta:"Kundnr",MetaN:"Kund_KundNr",Value:-1,Type:"Column"},
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column"},
                    
                    {Meta:"Rubrik",MetaN:"Avtal_Rubrik",Value:-1,Type:"Column"},
                    {Meta:"Värde",MetaN:"Avtal_TB",Value:-1,Type:"Column"},
                    {Meta:"Engångsintäkt Värde",MetaN:"Avtal_TB",Value:-1,Type:"Column"},
                    {Meta:"Löpande Värde",MetaN:"Avtal_MLopande",Value:-1,Type:"Column"},

                    {Meta:"Löpande",MetaN:"Avtal_MLopande",Value:-1,Type:"Column"},
                    {Meta:"Löper ut",MetaN:"Avtal_loperDatum",Value:-1,Type:"Column"},
                    {Meta:"Omförhandling",MetaN:"Avtal_omforDatum",Value:-1,Type:"Column"},
                    
                    {Meta:"Startdatum",MetaN:"Avtal_startDatum",Value:-1,Type:"Column"},
                    {Meta:"Avtalslängd",Value:-1,Type:"Column"},
                    {Meta:"Fakturaintervall",Value:-1,Type:"Column"},
                    {Meta:"Betalningsvillkor",Value:-1,Type:"Column"},
                    {Meta:"Löpande",Value:-1,Type:"Column"},
                    {Meta:"Periodstart",Value:-1,Type:"Column"},
                    {Meta:"Periodslut",Value:-1,Type:"Column"},

                    {Meta:"Status",MetaN:"Avtal_fakturastatus",Value:-1,Type:"Column"},
                    {Meta:"Ägare",MetaN:"Avtal_Ansvarig",Value:-1,Type:"Column"},

                    {Meta:"Kontaktperson namn",MetaN:"Kontaktperson_namn",Value:-1,Type:"Column"},
                    {Meta:"Kontaktperson epost",MetaN:"Kontaktperson_Epost",Value:-1,Type:"Column"},
                    {Meta:"Kontaktperson Tele",MetaN:"Kontaktperson_tele",Value:-1,Type:"Column"},
                    {Meta:"Kontaktperson personnr",MetaN:"Kontaktperson_personnr",Value:-1,Type:"Column"},

                    {Meta:"Taggar",MetaN:"Avtal_Taggning",Value:-1,Type:"Column"},
                ]
                setFilterstate(ArrItem)
            break;
            //Fakturor
            case "Fakturor":
                DisabledArr1={
                    Kund:false,Kontakter:true,Artiklar:true,Avtal:false,Prospekt:true,Event:true,
                Order:true,Esignering:true,Fakturering:false,Arende:true,Projekt:true,Aktiviteter:true,
                Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"AvtalID",MetaN:"Avtal_ID",MetaN:"AvtalID",Value:-1,Type:"Column"},

                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column"},
                    {Meta:"KundNR",MetaN:"Kund_KundNr",Value:-1,Type:"Column"},
                    {Meta:"KundID",MetaN:"Kund_KundId",Value:-1,Type:"Column"},
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column"},
                    
                    {Meta:"Typ",MetaN:"Typ",Value:-1,Type:"Column"},
                    {Meta:"Avtaltyp",MetaN:"Avtal_Typ",Value:-1,Type:"Column"},
                    {Meta:"FortnoxNr",MetaN:"FortnoxNr",Value:-1,Type:"Column"},
                    {Meta:"Ansvarig",MetaN:"Ansvarig",Value:-1,Type:"Column"},
                    {Meta:"Skapad",MetaN:"Skapad",Value:-1,Type:"Column"},
                    {Meta:"Betaltstatus",MetaN:"Betaltstatus",Value:-1,Type:"Column"},
                    {Meta:"Förfallodatum",MetaN:"Förfallodatum",Value:-1,Type:"Column"},
                    {Meta:"Fakturadatum",MetaN:"Fakturadatum",Value:-1,Type:"Column"},
                    {Meta:"Slutbetald",MetaN:"Slutbetald",Value:-1,Type:"Column"},
                    {Meta:"Total",MetaN:"Total",Value:-1,Type:"Column"},
                ]
                setFilterstate(ArrItem)
            break;
           
            //Artikeltaggar
            case "Artikeltaggar":
                DisabledArr1={
                    Kund:false,Kontakter:true,Artiklar:true,Avtal:true,Prospekt:true,Event:true,
                Order:true,Esignering:true,Fakturering:true,Arende:true,Projekt:true,Aktiviteter:true,
                Offert:true,
                }
                setDisabledArr(DisabledArr1) 
                ArrItem = [
                    {Meta:"Module",MetaN:"Module",Value:RapportType,Type:"Header"},
                    {Meta:"Orgnr",MetaN:"Kund_KundOrgnr",Value:-1,Type:"Column"},
                    {Meta:"KundNR",MetaN:"Kund_KundNr",Value:-1,Type:"Column"},
                    {Meta:"Kund",MetaN:"Kund_KundNamn",Value:-1,Type:"Column"},
                ]
                setFilterstate(ArrItem)
            break;
          
            */
        }
    }
    const onChangeChips = (isChecked,Chip,isMulti = 1,Chip1)=>{
        let Filterstate1 = Filterstate
       


        if(isMulti === 2){
            Filterstate1 = Filterstate.filter(item=> item.MetaN !== Chip.MetaN || (item.MetaN === Chip.MetaN && item.Value !== -1))
            Filterstate1.push(Chip)
        }
        else if(isMulti ===21){
            Filterstate1 = Filterstate.filter(item=> !(item.MetaN === Chip.MetaN && (item.Value === Chip.Value || item.Value === -1)))
            if(isChecked === true){
                Filterstate1.push(Chip)
            }          
        }
        else if(isMulti === 3){
            //isArray
            Chip.map(item2=>{
                Filterstate1 = Filterstate1.filter(item=>item.MetaN !== item2.MetaN)
                if(isChecked === true){
                    Filterstate1.push(item2)
                }
            })
        }
        else if(isMulti === 4){
            Filterstate1 = Filterstate1.filter(item=>item.MetaN !== Chip.MetaN && item.MetaN !== Chip1.MetaN)
            if(isChecked === true){
                Filterstate1.push(Chip)
                Filterstate1.push(Chip1)
            }
        }
        else if(isMulti === 5){
            Filterstate1 = Filterstate1.filter(item=>item.MetaN !== Chip.MetaN )
            Filterstate1.push(Chip)
        }
        else{
            Filterstate1 = Filterstate1.filter(item=>item.MetaN !== Chip.MetaN)
            if(isChecked === false){
                Filterstate1 = Filterstate1.filter(item=>item.MetaN !== Chip.MetaN && item.MetaN !== `${Chip.MetaN} T.O.M`
                    && item.MetaN !== `${Chip.MetaN} F.O.M`)
                if(Chip.MetaN === "Order_lopande_TB_Avdrag"){
                    Filterstate1 = Filterstate1.filter(item=>item.MetaN !==  "Order_lopande_TB2_Avdrag")
                }
                if(Chip.MetaN === "Kund_FriaFält"){
                    Filterstate1 = Filterstate1.filter(item=>item.MetaN !==  "OKund_FriaFält_Antal")
                    Filterstate1 = Filterstate1.filter(item=>!item.MetaN.includes("Kund_FriaFält_Parameter"))
                }
            }     
            if(isChecked === true){
                Filterstate1.push(Chip)
                if(Chip.MetaN === "Order_lopande_TB_Avdrag"){
                    Filterstate1.push({
                        ...Chip,
                        MetaN:"Order_lopande_TB2_Avdrag",
                        Meta:"Order2 TBavdrag"
                    })
                }
            }        
        }        
        console.log(Filterstate1,"Filterstate1")
        setFilterstate(Filterstate1)

    }
    const onGetRapport=()=>{
        console.log(beskrivning)
        dispatch(onGetRapportV2J(authUser.user_Afid,authUser.user_id,Name,SendTo,beskrivning,Filterstate))
        setOpenPop(false)
    }
    const onSaveThisRapport1=()=>{
        dispatch(onGetAndSaveRapportV2J(authUser.user_Afid,authUser.user_id,Name,SendTo,beskrivning,Filterstate,id))
        setOpenPop(false)
    }
    const onSaveThisRapport=()=>{
        dispatch(onGetAndSaveRapportV2J(authUser.user_Afid,authUser.user_id,Name,SendTo,beskrivning,Filterstate,0))
        setOpenPop(false)
    }
    React.useEffect(()=>{
        if(!isEmpty(Filterstate)){
            dispatch(getSamplesImport(authUser.user_Afid,authUser.user_id,Filterstate))
        }else{
            dispatch(setToZeroImportSample())
        }
    },[Filterstate])
    const GetThisRapport = (item)=>{
        setId(item.id)
        setName(item.Name)
        setSendTo(item.Email)
        setBeskrivning(item.Beskrivning)
        console.log(item.Chips,"item.Chips")
        //{"Meta":"Fria fält","MetaN":"Kund_FriaFält","Value":"264","Checked":true,"Type":"Column","isSwitch":true}//
        if(JSON.parse(item.Chips).some(item=>item.MetaN === "Kund_FriaFält")){
            let FValue = JSON.parse(item.Chips).find(item=>item.MetaN === "Kund_FriaFält").Value
            console.log(FValue,"FValue")
            dispatch(getCurrentObjektById(authUser.user_Afid,FValue, authUser.user_id))
        }
        setFilterstate(JSON.parse(item.Chips))
    }
    const handleKontoChange = (Konto)=>{
        //{Meta:"Konto",MetaN:"UKAf",Value:authUser.user_Afid,Type:"Column"},
        let Filterstate1= Filterstate
        if(Filterstate1.some(item=>item.MetaN==="UKAf")){
            Filterstate1= Filterstate1.filter(item=>item.MetaN !== "UKAf")            
        }
        Filterstate1.push({Meta:"Konto",MetaN:"UKAf",Value:Konto,Type:"ColumnH"})
        setFilterstate(Filterstate1)
    }
    return (
        <>
            <Dialog open={props.openRapport} 
              onClose={handleClose} 
              aria-labelledby="customized-dialog-title" 
              TransitionComponent={Transition}
              fullScreen 
            >
               <ModalHeader className="modal-box-header bg-primary text-white py-0" style={{borderRadius:0}}>
               <IntlMessages id="Report"/>
                    <IconButton className="text-white"
                        onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </ModalHeader> 
                <DialogContent style={{background:"#fafafa"}}>
                <XXLargeDesktop>
                <CustomScrollbars className="module-list-scroll scrollbar"
                style={{
                    //height:'Calc(100vh - 98px)', 
                    height:'Calc(100vh)', 
                    paddingTop:'4px' }}>
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ReactGridLayout
                    className="layout"
                    rowHeight={40}
                    style={{ width: '99%' }}
                    >
                        <Paper key="1"
                        data-grid={{ x: 0, y: 0,w: 8, h: 12, static: true }}>
                            <RapportFunctions
                            onChangeHandle={onChangeHandle}
                            Chips={Filterstate}
                            Flags={Flags}
                            authUser={authUser}
                            handleKontoChange={handleKontoChange}
                            />
                            <RapportSection
                            DisabledArr={DisabledArr}
                            Flags={Flags}
                            authUser={authUser}
                            Chips={Filterstate}
                            onChangeChips={onChangeChips}
                            />
                        </Paper>
                        <Paper  key="2"
                        data-grid={{ x: 0, y: 12,w: 8, h: 8, static: true }}>
                            <ExcelVy
                            Chips={Filterstate}
                            resetZeroChips={resetZeroChips}
                            />
                        </Paper>
                        <Paper key="3"
                        data-grid={{ x: 8, y: 0,w: 4, h: 8, static: true }}>
                            <SparadRapport
                            GetThisRapport={GetThisRapport}
                            />
                        </Paper>
                        <Paper key="4"
                        data-grid={{ x: 8, y: 8,w: 4, h: 12, static: true }}>
                            <RapportLogg/>
                        </Paper>
                    </ReactGridLayout>
                    </div>   
                </CustomScrollbars>
                </XXLargeDesktop>
                <ExtraLargeDesktop>
                <CustomScrollbars className="module-list-scroll scrollbar"
                style={{
                    //height:'Calc(100vh - 98px)', 
                    height:'Calc(100vh)', 
                    paddingTop:'4px' }}>
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ReactGridLayout
                    className="layout"
                    rowHeight={40}
                    style={{ width: '99%' }}
                    >
                         <Paper key="1"
                        data-grid={{ x: 0, y: 0,w: 12, h: 12, static: true }}>
                             <RapportFunctions
                            onChangeHandle={onChangeHandle}
                            Chips={Filterstate}
                            Flags={Flags}
                            authUser={authUser}
                            />
                            <RapportSection
                            DisabledArr={DisabledArr}
                            Flags={Flags}
                            authUser={authUser}
                            Chips={Filterstate}
                            onChangeChips={onChangeChips}
                            />
                        </Paper>
                        <Paper  key="2"
                        data-grid={{ x: 0, y: 12,w: 12, h: 8, static: true }}>
                            <ExcelVy
                            Chips={Filterstate}
                            resetZeroChips={resetZeroChips}
                            />
                        </Paper>
                        <Paper key="3"
                        data-grid={{ x: 0, y: 20,w: 6, h: 12, static: true }}>
                            <SparadRapport
                            GetThisRapport={GetThisRapport}
                            />
                        </Paper>
                        <Paper key="4"
                        data-grid={{ x: 6, y: 20,w: 6, h: 12, static: true }}>
                           <RapportLogg/>
                        </Paper>
                    </ReactGridLayout>
                    </div>   
                </CustomScrollbars>
                </ExtraLargeDesktop>
                <LargeDesktop>
                <CustomScrollbars className="module-list-scroll scrollbar"
                style={{
                    //height:'Calc(100vh - 98px)', 
                    height:'Calc(100vh)', 
                    paddingTop:'4px' }}>
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ReactGridLayout
                    className="layout"
                    rowHeight={40}
                    style={{ width: '99%' }}
                    >
                        <Paper key="1"
                        data-grid={{ x: 0, y: 0,w: 12, h: 12, static: true }}>
                             <RapportFunctions
                            onChangeHandle={onChangeHandle}
                            Chips={Filterstate}
                            Flags={Flags}
                            authUser={authUser}
                            />
                            <RapportSection
                            DisabledArr={DisabledArr}
                            Flags={Flags}
                            authUser={authUser}
                            Chips={Filterstate}
                            onChangeChips={onChangeChips}
                            />
                        </Paper>
                        <Paper  key="2"
                        data-grid={{ x: 0, y: 12,w: 12, h: 8, static: true }}>
                            <ExcelVy
                            Chips={Filterstate}
                            resetZeroChips={resetZeroChips}
                            />
                        </Paper>
                        <Paper key="3"
                        data-grid={{ x: 0, y: 20,w: 6, h: 12, static: true }}>
                            <SparadRapport
                            GetThisRapport={GetThisRapport}
                            />
                        </Paper>
                        <Paper key="4"
                        data-grid={{ x: 6, y: 20,w: 6, h: 12, static: true }}>
                           <RapportLogg/>
                        </Paper>
                    </ReactGridLayout>
                    </div>   
                </CustomScrollbars>
                </LargeDesktop>
                <Desktop>
                <CustomScrollbars className="module-list-scroll scrollbar"
                style={{
                    //height:'Calc(100vh - 98px)', 
                    height:'Calc(100vh)', 
                    paddingTop:'4px' }}>
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ReactGridLayout
                    className="layout"
                    rowHeight={40}
                    style={{ width: '99%' }}
                    >
                        <Paper key="1"
                        data-grid={{ x: 0, y: 0,w: 12, h: 12, static: true }}>
                             <RapportFunctions
                            onChangeHandle={onChangeHandle}
                            Chips={Filterstate}
                            Flags={Flags}
                            authUser={authUser}
                            />
                            <RapportSection
                            DisabledArr={DisabledArr}
                            Flags={Flags}
                            authUser={authUser}
                            Chips={Filterstate}
                            onChangeChips={onChangeChips}
                            />
                        </Paper>
                        <Paper  key="2"
                        data-grid={{ x: 0, y: 12,w: 12, h: 8, static: true }}>
                            <ExcelVy
                            Chips={Filterstate}
                            resetZeroChips={resetZeroChips}
                            />
                        </Paper>
                        <Paper key="3"
                        data-grid={{ x: 0, y: 20,w: 6, h: 12, static: true }}>
                            <SparadRapport
                            GetThisRapport={GetThisRapport}
                            />
                        </Paper>
                        <Paper key="4"
                        data-grid={{ x: 6, y: 20,w: 6, h: 12, static: true }}>
                           <RapportLogg/>
                        </Paper>
                    </ReactGridLayout>
                    </div>   
                </CustomScrollbars>
                </Desktop>
                <Tablet>
                    <CustomScrollbars className="module-list-scroll scrollbar"
                style={{
                    //height:'Calc(100vh - 98px)', 
                    height:'Calc(100vh)', 
                    paddingTop:'4px' }}>
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ReactGridLayout
                    className="layout"
                    rowHeight={30}
                    style={{ width: '99%' }}
                    >
                       <Paper key="1"
                        data-grid={{ x: 0, y: 0,w: 12, h: 16, static: true }}>
                             <RapportFunctions
                            onChangeHandle={onChangeHandle}
                            Chips={Filterstate}
                            Flags={Flags}
                            authUser={authUser}
                            />
                            <RapportSection
                            DisabledArr={DisabledArr}
                            Flags={Flags}
                            authUser={authUser}
                            Chips={Filterstate}
                            onChangeChips={onChangeChips}
                            />
                        </Paper>
                        <Paper key="2"
                        data-grid={{ x: 16, y: 0,w: 12, h: 9, static: true }}>
                            <SparadRapport
                            GetThisRapport={GetThisRapport}
                            />
                        </Paper>
                    </ReactGridLayout>
                    </div>   
                </CustomScrollbars></Tablet>
                <Mobile>
                <CustomScrollbars className="module-list-scroll scrollbar"
                style={{
                    //height:'Calc(100vh - 98px)', 
                    height:'Calc(100vh)', 
                    paddingTop:'4px' }}>
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ReactGridLayout
                    className="layout"
                    rowHeight={30}
                    style={{ width: '99%' }}
                    >
                        <Paper key="1"
                        data-grid={{ x: 0, y: 0,w: 12, h: 16, static: true }}>
                              <RapportFunctions
                            onChangeHandle={onChangeHandle}
                            Chips={Filterstate}
                            Flags={Flags}
                            authUser={authUser}
                            />
                            <RapportSection
                            DisabledArr={DisabledArr}
                            Flags={Flags}
                            authUser={authUser}
                            Chips={Filterstate}
                            onChangeChips={onChangeChips}
                            />
                        </Paper>
                        <Paper key="2"
                        data-grid={{ x: 16, y: 0,w: 12, h: 9, static: true }}>
                            <SparadRapport
                            GetThisRapport={GetThisRapport}
                            />
                        </Paper>
                    </ReactGridLayout>
                    </div>   
                </CustomScrollbars>
                </Mobile>
                   
                </DialogContent>
                <div className="d-flex py-2 mx-2 border-top">
                <div style={{margin:"auto 2px", color:"#343a40"}}>
                {isEmpty(Filterstate)?"":
                isEmpty(ImportSamplesMessage)?"":<div style={{
                    display: "flex", gap: "10px", alignItems: "end",
                }}>
                <span>{
                    ImportSamplesMessage.status === 'error'?
                    <WarningIcon color="secondary"/>
                    :
                    ImportSamplesMessage.status === 'info'?
                    <FiberManualRecordIcon color="primary"/>
                    :""
                    }</span>
                <span>{ImportSamplesMessage.Message}</span>
                </div>}
                </div>
                <div className="ml-auto">
              {/*  <TextField 
                variant="outlined" 
                style={{width:350,marginRight:10}}
                defaultValue=""
                size="small"
                name="Email"
                label={<IntlMessages id="Label.send.to.Email"/>}
                value={SendTo}
                InputLabelProps={{ shrink: true }}
                onChange={(e)=>{setSendTo(e.target.value)}}
                />
                */}
                <Button
                variant="contained"
                color="primary"
                size="small"
                disabled={isEmpty(Filterstate)}
                onClick={onOpenSavePopUp}
                //onClick={this.RapportBythis}
                //onClick={this.AskForSaving}
                ><IntlMessages id="Report.Create"/>
                </Button>
                </div>
                </div>
                {openPop === true?
                <SkapaRapportPopUp
                onGetRapport={onGetRapport}
                onSaveThisRapport={onSaveThisRapport}
                onSaveThisRapport1={onSaveThisRapport1}
                onClose={onCloseSavePopUp}
                Name={Name}
                onSetThisName={(Name)=>setName(Name)}
                Email={SendTo}
                id={id}
                onSetThisEmail={(Email)=>setSendTo(Email)}
                beskrivning={beskrivning}
                onSetThisBeskrivning={(beskrivning)=>setBeskrivning(beskrivning)}
                />
                :""}
            </Dialog>
        </>
    );
}

export default RapportV2;